import Vue from 'vue';

export default Vue.directive('node', {
    bind: function (el, binding) {
        // Make sure expression provided is a function
        console.log(el, 'node append', binding)
        if(binding.value) {
            el.appendChild(binding.value);
        }
    }
})